import React from "react"
import BackupIcon from "@material-ui/icons/Backup"
import BuildIcon from "@material-ui/icons/Build"
import CollectionsBookmarkIcon from "@material-ui/icons/CollectionsBookmark"
import LockIcon from "@material-ui/icons/Lock"
import MusicNoteIcon from "@material-ui/icons/MusicNote"
import SportsTennisIcon from "@material-ui/icons/SportsTennis"
import TimelineIcon from "@material-ui/icons/Timeline"
import TvIcon from "@material-ui/icons/Tv"

export default {
  BackupIcon: <BackupIcon />,
  BuildIcon: <BuildIcon />,
  CollectionsBookmarkIcon: <CollectionsBookmarkIcon />,
  LockIcon: <LockIcon />,
  MusicNoteIcon: <MusicNoteIcon />,
  SportsTennisIcon: <SportsTennisIcon />,
  TimelineIcon: <TimelineIcon />,
  TvIcon: <TvIcon />,
}
